module.exports = __webpack_public_path__ + "img/textile.98ffc0ca.svg";